import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';

// Only English is bundled. The other 17 locales (~500 KB of JSON together) are
// code-split and fetched the first time that language becomes active, so the
// main bundle — parsed on every page view — doesn't carry translations most
// visitors never use. Until a locale's chunk arrives, t() falls back to English
// (fallbackLng), so there's no flash of raw keys, just English text that swaps.
const LAZY_LOCALES = ['hi', 'es', 'fr', 'de', 'zh', 'ru', 'it', 'pt', 'nl', 'pl', 'uk', 'tr', 'ro', 'el', 'sv', 'cs', 'hu'];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // Only `en` up front; ensureLocale() below adds the others via addResourceBundle.
    // (No partialBundledLanguages: that flag routes loading through a backend plugin,
    // which we don't use, and changes i18next's load timing.)
    resources: { en: { translation: en } },
    fallbackLng: 'en',
    detection: {
      order: ['querystring', 'navigator', 'localStorage'],
      lookupQuerystring: 'lang',
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
    initImmediate: false,
  });

function ensureLocale(lng) {
  const code = (lng || '').split('-')[0];
  if (!LAZY_LOCALES.includes(code) || i18n.hasResourceBundle(code, 'translation')) return;
  import(/* webpackChunkName: "locale-[request]" */ `./locales/${code}.json`)
    .then((mod) => {
      i18n.addResourceBundle(code, 'translation', mod.default || mod, true, true);
      // Re-emit languageChanged so react-i18next re-renders with the loaded strings.
      if ((i18n.language || '').split('-')[0] === code) i18n.changeLanguage(i18n.language);
    })
    .catch(() => { /* stay on the English fallback */ });
}

i18n.on('languageChanged', ensureLocale);
ensureLocale(i18n.language);

export default i18n;

export const LANGUAGES = [
  { code: 'en', label: 'English', flag: '🇺🇸' },
  { code: 'hi', label: 'हिन्दी', flag: '🇮🇳' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { code: 'zh', label: '中文', flag: '🇨🇳' },
  { code: 'ru', label: 'Русский', flag: '🇷🇺' },
  { code: 'it', label: 'Italiano', flag: '🇮🇹' },
  { code: 'pt', label: 'Português', flag: '🇵🇹' },
  { code: 'nl', label: 'Nederlands', flag: '🇳🇱' },
  { code: 'pl', label: 'Polski', flag: '🇵🇱' },
  { code: 'uk', label: 'Українська', flag: '🇺🇦' },
  { code: 'tr', label: 'Türkçe', flag: '🇹🇷' },
  { code: 'ro', label: 'Română', flag: '🇷🇴' },
  { code: 'el', label: 'Ελληνικά', flag: '🇬🇷' },
  { code: 'sv', label: 'Svenska', flag: '🇸🇪' },
  { code: 'cs', label: 'Čeština', flag: '🇨🇿' },
  { code: 'hu', label: 'Magyar', flag: '🇭🇺' },
];
